<div
  [id]="idDiv"
  class="bg-box-21 overflow-y w-100 h-100 {{ classDiv }}"
  [ngClass]="{ 'flex align-items-center justify-content-center': !!center }">
  <div class="w-100 px-16 {{ classSubDiv }}">
    <ng-content></ng-content>
  </div>
</div>
